import React from "react";

const typography = {
  body1: {
    // color: palette.text.primary,
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    // color: palette.text.secondary,
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: 1.14,
  },
  button: {
    // color: palette.primary.main,
    fontWeight: 700,
    // textAlign: "center",
    textTransform: "none" as React.CSSProperties["textTransform"],
  },
  caption: {
    // color: palette.text.secondary,
    fontSize: "12px",
    lineHeight: 1.33,
  },
  fontFamily: "Open Sans",
  h1: {
    fontFamily: "Poppins",
    fontSize: "40px",
    // color: palette.text.primary,
    fontWeight: 800,
    lineHeight: 1.6,
  },
  h2: {
    fontFamily: "Poppins",
    fontSize: "36px",
    // color: palette.text.primary,
    fontWeight: 800,
    lineHeight: 1.55,
  },
  h3: {
    fontFamily: "Poppins",
    fontSize: "32px",
    // color: palette.text.primary,
    fontWeight: 800,
    lineHeight: 1.5,
  },
  h4: {
    fontFamily: "Poppins",
    fontSize: "24px",
    // color: palette.text.primary,
    fontWeight: 800,
    lineHeight: 1.33,
  },
  h5: {
    fontFamily: "Poppins",
    fontSize: "18px",
    // color: palette.text.primary,
    fontWeight: 800,
    lineHeight: 1.33,
  },
  h6: {
    fontFamily: "Poppins",
    fontSize: "16px",
    // color: palette.text.primary,
    fontWeight: 800,
    lineHeight: 1.5,
    margin: 0,
  },
  overline: {
    fontSize: "14px",
    // textTransform: "uppercase",
    fontWeight: "bold",
    lineHeight: 1.14,
  },
  subtitle1: {
    // color: palette.text.primary,
    fontSize: "16px",
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: "14px",
    // color: palette.text.secondary,
    fontWeight: 400,
    lineHeight: 1.5,
  },
};

export default typography;
